import { sendBeacon } from '../utils/http'

export function pclnHTTPWebHandler(options = {}, async = true) {
  return new Promise((resolve, reject) => {
    const type = options.type || options.data ? 'POST' : 'GET'
    const data = options.data && type === 'POST' ? JSON.stringify(options.data) : undefined

    if (options.beacon) {
      sendBeacon(options.url, data)
    } else {
      const xhr = new XMLHttpRequest()

      xhr.addEventListener('load', (response) => {
        resolve(response)
      })
      xhr.addEventListener('error', (error) => reject(error))
      xhr.open(type, options.url, async)

      if (type === 'POST') {
        xhr.setRequestHeader('Content-Type', 'application/json')
      }

      xhr.send(data)
    }
  })
}
